import React from "react";

import { Row, Column } from "components/Layout";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';
import NTMButton from "components/Buttons/NTMButton";


async function downloadImage(
	imageSrc,
	nameOfDownload = 'my-image.png',
) {
	const response = await fetch(imageSrc);
	const blobImage = await response.blob();

	const href = URL.createObjectURL(blobImage);

	const anchorElement = document.createElement('a');
	anchorElement.href = href;
	anchorElement.download = nameOfDownload;

	document.body.appendChild(anchorElement);
	anchorElement.click();

	document.body.removeChild(anchorElement);
	window.URL.revokeObjectURL(href);
}


export default function DeviceQrModal({
	isOpen, onClose, device,
}) {

	if (!device || !device.deviceId)
		return null

	// genero il qrcode mediante il servizio https://goqr.me/
	let qrcodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=https://magico.waiv.it/devices/${device.deviceId}&amp;size=100x100`
	let downloadName = `magico-qr-${device.deviceId}`

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} submitButtonDisabled={true} >
			<Column className={style.section}>
				<Row className={style.title}>
					{`QR code - ${device.deviceId}`}
				</Row>
				<Row>
					<img
						alt={downloadName}
						src={qrcodeUrl}
					/>
				</Row>
				<Row>
					<NTMButton onClick={() => downloadImage(qrcodeUrl, downloadName)}>
						Download
					</NTMButton>
				</Row>
			</Column>
		</ElementModal>
	)
}
